(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BedDialogController', BedDialogController);

    BedDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Bed', 'Room', 'CoreService'];

    function BedDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Bed, Room, CoreService) {
        var vm = this;

        vm.bed = entity;
        vm.facility = CoreService.getCurrentFacility();
        vm.rooms = Room.byfacility({id: vm.facility.id});
        vm.status = ['ACTIVE','MAINTENANCE','CLEANING','INACTIVE'];

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function save () {
            vm.isSaving = true;
            if (vm.bed.id !== null) {
                Bed.update(vm.bed, onSaveSuccess, onSaveError);
            } else {
                Bed.save(vm.bed, onSaveSuccess, onSaveError);
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:bedUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
